import { takeLatest, call, put } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  getTierRequested,
  getTierSucceeded,
  getTierFailed,
  createTierRequested,
  createTierSucceeded,
  createTierFailed,
} from '../reducers/tier.slice';
import TierAPIService from '../../services/tier.service';

function* getAll(action: PayloadAction<{ projectId: number }>): Generator<unknown, void, unknown> {
  try {
    const service = new TierAPIService();
    const data = yield call([service, service.getAll], action.payload);

    yield put({ type: getTierSucceeded.type, payload: data });
  } catch (error: any) {
    yield put<{ type: string; payload: SagaError }>({ type: getTierFailed.type, payload: { message: error.message } });
  }
}

function* create(action: PayloadAction<{ projectId: number; tier: Tier }>): Generator<unknown, void, unknown> {
  try {
    const service = new TierAPIService();
    const data = yield call([service, service.create], action.payload);

    yield put({ type: createTierSucceeded.type, payload: data });
  } catch (error: any) {
    yield put<{ type: string; payload: SagaError }>({
      type: createTierFailed.type,
      payload: { message: error.message },
    });
  }
}

export default function* watchAsync() {
  yield takeLatest(getTierRequested.type, getAll);
  yield takeLatest(createTierRequested.type, create);
}
